(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["choiceSection"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', videoScroll);
  window.addEventListener('scroll', videoScroll);

  function videoScroll() {

    if ( document.querySelectorAll('video[loop]').length > 0) {
      var windowHeight = window.innerHeight,
          videoEl = document.querySelectorAll('video[loop]');

      for (var i = 0; i < videoEl.length; i++) {

        var thisVideoEl = videoEl[i],
            videoHeight = thisVideoEl.clientHeight,
            videoClientRect = thisVideoEl.getBoundingClientRect().top;

        if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
          thisVideoEl.play();
          // console.log("video playing");
        } else {
          thisVideoEl.pause();
          // console.log("video is not playing");
        }

      }
    }

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let downloadButton = document.getElementById('download');

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      downloadButton.setAttribute(
        'href',
        'https://play.google.com/store/apps/details?id=com.viatek.fitnation.echelon_android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
      );
    } else if (/android/i.test(userAgent)) {
      downloadButton.setAttribute(
        'href',
        'https://play.google.com/store/apps/details?id=com.viatek.fitnation.echelon_android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
      );
    }

    // iOS detection
    else if (/Mac|iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      downloadButton.setAttribute('href', 'https://apps.apple.com/us/app/echelon-fitness/id1262424186');
    } else {
      downloadButton.setAttribute(
        'href',
        'https://play.google.com/store/apps/details?id=com.viatek.fitnation.echelon_android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-plans"] && !Shopify.designMode) return;
  try {
    
  class MembershipPlanSelector {
    constructor(container) {
      this.container = container;
      this.selector = container.querySelector('[data-plan-selector]');
      this.button = container.querySelector('[data-premier-button]');
      this.buttonText = this.button?.querySelector('[data-button-text]');
      this.options = this.selector?.querySelectorAll('.plan-selector__option');

      this.#init();
    }

    #init() {
      if (!this.selector || !this.button) return;

      for (const option of this.options) {
        option.addEventListener('click', () => this.#handleOptionClick(option));
      }
    }

    #handleOptionClick(selectedOption) {
      // Remove selected state from all options
      for (const option of this.options) {
        option.classList.remove('plan-selector__option--selected');
      }

      // Add selected state to clicked option
      selectedOption.classList.add('plan-selector__option--selected');

      // Update button text
      this.#updateButtonText(selectedOption);
    }

    #updateButtonText(option) {
      const plan = option.dataset.plan;
      const label = option.dataset.label;
      const price = option.dataset.price;

      if (this.buttonText) {
        let totalPrice = '';

        if (plan === 'yearly') {
          totalPrice = ' ($399.99)';
        } else if (plan === '2year') {
          totalPrice = ' ($799.99)';
        }

        this.buttonText.textContent = `BUY PREMIER ${label.toUpperCase()} $${price}/mo${totalPrice}`;
      }
    }
  }

  const membershipSection = document.querySelector('#MembershipPlans-{{ section.id }}');
  if (membershipSection) {
    new MembershipPlanSelector(membershipSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membershipSection"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', videoScroll);
  window.addEventListener('scroll', videoScroll);

  function videoScroll() {

    if ( document.querySelectorAll('video[loop]').length > 0) {
      var windowHeight = window.innerHeight,
          videoEl = document.querySelectorAll('video[loop]');

      for (var i = 0; i < videoEl.length; i++) {

        var thisVideoEl = videoEl[i],
            videoHeight = thisVideoEl.clientHeight,
            videoClientRect = thisVideoEl.getBoundingClientRect().top;

        if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
          thisVideoEl.play();
          // console.log("video playing");
        } else {
          thisVideoEl.pause();
          // console.log("video is not playing");
        }

      }
    }

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-comparison"] && !Shopify.designMode) return;
  try {
    
  class SubscriptionPlanSelector {
    constructor(container) {
      this.container = container;
      this.selector = container.querySelector('[data-plan-selector]');
      this.button = container.querySelector('[data-premier-button]');
      this.buttonText = this.button?.querySelector('[data-button-text]');
      this.options = this.selector?.querySelectorAll('.plan-selector__option');

      this.#init();
    }

    #init() {
      if (!this.selector || !this.button) return;

      for (const option of this.options) {
        option.addEventListener('click', () => this.#handleOptionClick(option));
      }
    }

    #handleOptionClick(selectedOption) {
      for (const option of this.options) {
        option.classList.remove('plan-selector__option--selected');
      }

      selectedOption.classList.add('plan-selector__option--selected');

      this.#updateButtonText(selectedOption);
      this.#updateButtonUrl(selectedOption);
    }

    #updateButtonText(option) {
      const plan = option.dataset.plan;
      const label = option.dataset.label;
      const price = option.dataset.price;
      const totalPrice = option.dataset.totalPrice;
      const buttonSubtext = this.button?.querySelector('[data-button-subtext]');

      if (this.buttonText) {
        let text = `BUY PREMIER ${label.toUpperCase()}`;
        let subtext = '';

        if (plan === 'yearly') {
          text = `BUY PREMIER YEARLY`;
          subtext = `$33.33/mo ($${totalPrice})`;
        } else if (plan === '2year') {
          text = `BUY PREMIER 2 YEAR`;
          subtext = `$${price}/mo ($${totalPrice})`;
        } else {
          text = `BUY PREMIER ${label.toUpperCase()}`;
          subtext = `$${price}/mo`;
        }

        this.buttonText.textContent = text;

        if (buttonSubtext) {
          buttonSubtext.textContent = subtext;
        }
      }
    }

    #updateButtonUrl(option) {
      const plan = option.dataset.plan;
      const urlMap = {
        monthly: '{{ section.settings.premier_monthly_url }}',
        yearly: '{{ section.settings.premier_yearly_url }}',
        '2year': '{{ section.settings.premier_two_year_url }}'
      };

      if (urlMap[plan] && this.button) {
        this.button.href = urlMap[plan];
      }
    }
  }

  const subscriptionSection = document.querySelector('#SubscriptionComparison-{{ section.id }}');
  if (subscriptionSection) {
    new SubscriptionPlanSelector(subscriptionSection);
  }

  } catch(e) { console.error(e); }
})();
})();
